// Only works in dev env

'use client';

import { JSX, useEffect } from 'react';

export function ReactGrab(): JSX.Element {
  useEffect(() => {
    import('react-grab');
  }, []);

  return <></>;
}
